// See _breakpoints.scss
export enum Breakpoint {
  ExtraSmall = 320,
  Small = 480,
  MediumSmall = 768,
  Medium = 900,
  MediumLarge = 1080,
  Large = 1440,
  Larger = 1680,
  ExtraLarge = 1920,
}

export function lower(breakpoint: Breakpoint): string {
  return `(max-width: ${breakpoint}px)`;
}
export function greater(breakpoint: Breakpoint): string {
  return `(min-width: ${breakpoint+1}px)`;
}
